export const isCustomerWebViewEnabled = (state) =>
  state.authentication.customerWebViewEnabled;
export const isEmbeddedInIFrame = (state) => state.authentication.isIFrame;
export const isSalesforceRep = (state) => state.authentication.isSalesforceRep;
export const getIsMobileParam = (state) => state.authentication.isMobileParam;
export const getApplicationApiKey = (state) =>
  state.applicationConfig.apikey || {};
